<template>
  <div>
    <div :class="{'ei-header':true,'show':headerShow}"  @mouseover="clearHeaderTimer" @mouseout="initHeaderTimer" >
      <div class="d2">
        <div class="block ei-header-content">
          <div :class="{'module anim-opacity1':true,'none':none,'active0':active0}">
            <div class="logo">
              <a @click="toHome()">
                <img src="./_ei-header/logo1-1.png" title="" alt="" class="logo-img">
              </a>
            </div>
            <div class="nav_main">
              <a @click="toPersonDetail('王羲之')" v-text="'王羲之'"></a>
              <a @click="toPersonDetail('褚遂良')" v-text="'褚遂良'"></a>
              <a @click="toPersonDetail('颜真卿')" v-text="'颜真卿'"></a>
              <a @click="toPersonDetail('苏轼')" v-text="'苏轼'"></a>
              <a @click="toPersonDetail('黄庭坚')" v-text="'黄庭坚'"></a>
              <a @click="toPersonDetail('米芾')" v-text="'米芾'"></a>
              <a @click="toPersonDetail('赵孟頫')" v-text="'赵孟頫'"></a>
              <div class="chengping">
                <div>诚聘出版合作伙伴</div>
              </div>
            </div>
          </div>
          <div :class="{'module anim-opacity1':true,'none':!none,'active0':!active0}" style="position: absolute">
            <div class="logo">
              <a @click="$router.push('/Home')">
                <img src="./_ei-header/logo2-1.png" title="" alt="" class="logo-img">
              </a>
            </div>
            <div class="nav_main">
              <a @click="toPersonDetail('阎立本')" v-text="'阎立本'"></a>
              <a @click="toPersonDetail('张萱')" v-text="'张萱'"></a>
              <a @click="toPersonDetail('吴道子')" v-text="'吴道子'"></a>
              <a @click="toPersonDetail('韩滉')" v-text="'韩滉'"></a>
              <a @click="toPersonDetail('韩干')" v-text="'韩干'"></a>
              <a @click="toPersonDetail('武宗元')" v-text="'武宗元'"></a>
              <a @click="toPersonDetail('李公麟')" v-text="'李公麟'"></a>
              <div class="chengping">
                <div>诚聘文旅合作伙伴</div>
              </div>
            </div>
          </div>
          <!--          <div class="tools">-->
          <!--            <a @click="$router.push('/Login')" v-if="!token">登录/注册</a>-->
          <!--            <a v-else @click="$router.push('/MemberInfo')" class="iconfont icon-geren" style="font-size: 30px"></a>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
    <div :class="{'ei-header2':true,'show':header2Show,'lit':header2Lit}"  @mouseover="clearHeaderTimer" @mouseout="initHeaderTimer" >
      <div class="d1" >
        <div class="block ei-header-content">
          <div class="nav_l">
            <a @click="$router.push('/Home')">首页</a><i>|</i>
            <a @click="$router.push('/WorksShow')">作品展览</a><i>|</i>
            <a @click="$router.push('/CulturalCreation')">学术文创</a><i>|</i>
            <a @click="$router.push('/Cooperation')">合作共赢</a><i>|</i>
            <a @click="$router.push('/Copyright')">版权声明</a>
          </div>
          <div class="nav_r">
            <a @click="$router.push('/EbookShow')">电子书</a>
            <a @click="$router.push('/ScrollShow')">卷轴</a>
            <a @click="$router.push('/AlbumShow')">册页</a>
            <a @click="$router.push('/AboutUs')">关于我们</a>
          </div>
        </div>
      </div>
      <div class="d2">
<!--        <div style="margin-left: 1680px;width: 300px;height: 80px;position: absolute"  @click="playorOrpauseMusic">
&lt;!&ndash;        <div style="position: absolute;margin-top: 21px;margin-left: 90.2px;" >
        <i class="el-icon-video-pause" v-if="this.audio.playing==true" style="color:saddlebrown;font-size: 25px;font-weight: bolder"></i>
        <i class="el-icon-caret-right" v-else  style="color: black;font-size: 25px;font-weight: bolder"></i>
        </div>&ndash;&gt;
        <div id="musicImage">
          <img class="song-img" ref="rotate" src="./_ei-header/aa.jpg">
          <audio ref="audio"  autoplay="autoplay"
                 :src="musicAttach.url"  preload="true"
                 loop="loop"  muted="muted"
                 style="width: 300px"
          ></audio>
        </div>
          <span style="position: absolute;margin-top: 45px;letter-spacing:1px;font-size: 14px;font-weight: bolder" v-if="musicAttach.musicName">{{ (musicAttach.musicName).replace(".mp3","")}}</span>
        </div>-->
        <div class="block ei-header-content">
          <div :class="{'module anim-opacity1':true,'none':none,'active0':active0}">
            <div class="logo">
              <a @click="toHome()">
                <img src="./_ei-header/logo1-2.png" title="" alt="" class="logo-img">
              </a>
            </div>
            <div class="nav_main">
              <a @click="toPersonDetail('王羲之')" v-text="'王羲之'"></a>
              <a @click="toPersonDetail('褚遂良')" v-text="'褚遂良'"></a>
              <a @click="toPersonDetail('颜真卿')" v-text="'颜真卿'"></a>
              <a @click="toPersonDetail('苏轼')" v-text="'苏轼'"></a>
              <a @click="toPersonDetail('黄庭坚')" v-text="'黄庭坚'"></a>
              <a @click="toPersonDetail('米芾')" v-text="'米芾'"></a>
              <a @click="toPersonDetail('赵孟頫')" v-text="'赵孟頫'"></a>
              <div class="chengping2">
                <div>诚聘出版合作伙伴</div>
              </div>
            </div>
          </div>
          <div :class="{'module anim-opacity1':true,'none':!none,'active0':!active0}" style="position: absolute">
            <div class="logo">
              <a @click="$router.push('/Home')">
                <img src="./_ei-header/logo2-2.png" title="" alt="" class="logo-img">
              </a>
            </div>
            <div class="nav_main">
              <a @click="toPersonDetail('阎立本')" v-text="'阎立本'"></a>
              <a @click="toPersonDetail('张萱')" v-text="'张萱'"></a>
              <a @click="toPersonDetail('吴道子')" v-text="'吴道子'"></a>
              <a @click="toPersonDetail('韩滉')" v-text="'韩滉'"></a>
              <a @click="toPersonDetail('韩干')" v-text="'韩干'"></a>
              <a @click="toPersonDetail('武宗元')" v-text="'武宗元'"></a>
              <a @click="toPersonDetail('李公麟')" v-text="'李公麟'"></a>
              <div class="chengping2">
                <div>诚聘文旅合作伙伴</div>
              </div>
            </div>
          </div>
          <!--          <div class="tools">-->
          <!--            <a @click="$router.push('/Login')" v-if="!token">登录/注册</a>-->
          <!--            <ei-head-info v-else-->
          <!--                          :info="$store.state.userInfo"-->
          <!--                          style="position: absolute;top: 11px;right: 0"-->
          <!--                          @onHandleLogoutClick="logout"></ei-head-info>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {queryOneMusic} from '@/api/reception/works-api'
export default {
  name: 'EiHeader',
  props: {
    headerShow: {
      type: Boolean,
      default: false
    },
    header2Show: {
      type: Boolean,
      default: false
    },
    header2Lit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      width: '70%',
      clientWidth: `${document.documentElement.clientWidth}`,
      token: '',
      none: false,
      active0: false,

    }
  },
  created() {
    this.token = this.$cookies.get('token')
    console.log(this.token)
    if (!!this.token) {
      this.$store.commit('setUserInfo')
    }
    this.initHeaderTimer()
  },
  mounted() {
    window.onresize = function () {
      console.log('clientWidth' + `${document.documentElement.clientWidth}`)
    }
  },
  methods: {
    toPersonDetail(name) {
      this.$router.push({
        path: '/PersonDetail',
        query: {name: name}
      })
    },
    toHome() {
      this.$router.push({
        path: '/Home',
      })
    },
    logout() {
      this.token = ''
      this.$cookies.remove('token')
      this.$router.push('/Home')
    },
    clearHeaderTimer() {
      clearInterval(this.headerOneTimer)
      this.headerOneTimer = null
    },
    initHeaderTimer() {
      this.headerOneTimer = setInterval(() => {
        setTimeout(() => {
          this.active0 = !this.active0
          setTimeout(() => {
            this.none = !this.none
          }, 1000)
        }, 1500)
      }, 5000)
    },
   /* playorOrpauseMusic(){
      if(this.audio.playing){
        this.$refs.audio.pause();
        this.audio.playing=false;
        this.$refs.rotate.style.animationPlayState = 'paused';
      }else {
        this.$refs.audio.play();
        this.audio.playing=true;
        this.$refs.rotate.style.animationPlayState = 'running';
      }
    },*/
  },
}
</script>

<style scoped lang="scss">
@import "./css/ei-common";
@import "./css/ei-anim";
@import "./css/ei-font.css";

@media screen and (min-width: 1660px) {
  .ei-header-content {
    width: 80%;
  }
}

@media screen and (min-width: 1440px) and (max-width: 1660px) {
  .ei-header-content {
    width: 80%;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1440px) {
  .ei-header-content {
    width: 90%;

  }
  .ei-header .nav_main a, .ei-header2 .nav_main a {
    margin: 0 15px !important;
  }
}

@media screen and (min-width: 960px) and (max-width: 1200px) {
  .ei-header-content {
    width: 95%;

  }
  .ei-header .nav_main a, .ei-header2 .nav_main a {
    margin: 0 10px !important;
  }
}

@media screen and (min-width: 540px) and (max-width: 960px) {
  .ei-header-content {
    width: 95%;

  }

  .ei-header .nav_main, .ei-header2 .nav_main {
    display: none;
  }

  .ei-header2 .d1 {
    display: none;
  }

}

.chengping {
  position: relative;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  width: 70px;
  display: inline-block;
  margin-left: 50px;
  height: 67px;
  vertical-align: middle;

  > div {
    position: absolute;
    top: 10px;
  }
}

.chengping2 {
  position: relative;
  font-size: 16px;
  line-height: 20px;
  width: 70px;
  display: inline-block;
  margin-left: 50px;
  height: 67px;
  vertical-align: middle;

  > div {
    position: absolute;
    top: 10px;
  }
}

.ei-header {
  position: fixed;
  left: 0%;
  top: 0;
  right: 0%;
  z-index: 3;
  transition: all 0.7s ease-out 0s;
  opacity: 0;
  transform: translateY(-100%);
}

.ei-header.show {
  opacity: 1;
  transform: none;
}

.ei-header .d1 {
  background: #94070a;
  color: #d39797;
  line-height: 45px;
  height: 45px;
  font-size: 14px;
  transition: all 0.2s ease-out 0s;
  overflow: hidden;
}

.ei-header.lit .d1 {
  height: 0;
}

.ei-header .d1 .nav_l i {
  margin: 0 18px;
  font-size: 12px;
}


.ei-header .d1 .nav_l a {
  display: inline-block;
  line-height: 1;
}

.ei-header .d1 .nav_l a:before {
  content: "";
  display: block;
  margin-bottom: 5px;
  border-top: 2px solid #d39797;
  transition: all 0.1s ease-out 0s;;
  transform: scaleX(0);
}

.ei-header .d1 .nav_l a.now {
  color: #fff;
}

.ei-header .d1 .nav_l a.now:before {
  transform: scaleX(1);
  border-color: #fff;
}

.ei-header .d1 .nav_l a:hover:before {
  transform: scaleX(1);
  border-color: #fff;
}

.ei-header .d1 .nav_r a {
  margin-left: 30px;
}

.ei-header .d1 .nav_r a {
  display: inline-block;
  line-height: 1;
}

.ei-header .d1 .nav_r a:before {
  content: "";
  display: block;
  margin-bottom: 5px;
  border-top: 2px solid #d39797;
  transition: all 0.1s ease-out 0s;;
  transform: scaleX(0);
}

.ei-header .d1 .nav_r a.now {
  color: #fff;
}

.ei-header .d1 .nav_r a.now:before {
  transform: scaleX(1);
  border-color: #fff;
}

.ei-header .d1 .nav_r a:hover:before {
  transform: scaleX(1);
  border-color: #fff;
}

.ei-header .d2 {
  transition: all 0.3s ease-out 0s;
  height: 85px;
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
}


.ei-header .block {
  position: relative;
  height: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-align: center;
  align-items: center;
  margin: auto;
}

.ei-header .logo {
  height: 100%;
  width: 200px;
  min-width: 350px;
  display: inline-block;
  margin-left: 30px;
  vertical-align: top;
}

.ei-header .logo a {
  height: 100%;
  font-size: 0;
  display: block;
}

.ei-header .logo img {
  vertical-align: middle;
  display: inline-block;
  height: 60px;
}

.ei-header .logo a:after {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

.ei-header .nav_main {
  text-align: center;
  font-size: 18px;
  margin-left: 30px;
  display: inline-block;
  height: 60px;
  line-height: 60px
}

.ei-header .nav_main a {
  width: 80px;
  margin: 0 25px;
  color: #fff;
  display: inline-block;
  position: relative;
  font-size: 24px;
}

.ei-header .nav_main a:after {
  content: "";
  border-bottom: 2px solid #94070a;
  margin-top: 5px;
  display: block;
  width: 100%;
  transition: all 0.2s ease-out 0s;
  transform: scaleX(0);
}

.ei-header .nav_main a:before {
  content: "";
  border-left: 2px solid #94070a;
  height: 25px;
  transition: all 0.2s ease-out 0s;
  transform: scaleY(0);
  position: absolute;
  left: 50%;
  top: 100%;
  transform-origin: center top;
}

.ei-header .nav_main a.hover:before {
  transform: none;
}

.ei-header .nav_main a.now:after {
  transform: none;
}

.ei-header .nav_main a.hover:after {
  transform: none;
}

.ei-header .tools {
  color: #fff;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.ei-header .tools .a {
  border: 1px solid #fff;
  border-radius: 100%;
  margin-left: 20px;
  width: 34px;
  height: 34px;
  line-height: 34px;
  position: relative;
}

.ei-header .tools .a > a {
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  height: 100%;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.ei-header .tools .sc a:after {
  content: "\e672";
  font-size: 20px;
  font-family: icon, serif;
}

.ei-header .tools .log i:after {
  content: "\e601";
  font-size: 20px;
  font-family: icon, serif;
}


.ei-header .tools .share-box {
  float: left;
}

.ei-header .tools .lang {
  font-size: 16px;
  text-transform: uppercase;
  font-family: Arial, serif;
}

.ei-header .tools .search {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  width: 250px;
  height: 36px;
  position: absolute;
  right: -2px;
  top: 0;
  opacity: 0;
  filter: alpha(opacity='0');
  visibility: hidden;
  transition: all 0.2s ease-out 0s;
  -webkit-transition: all 0.2s ease-out 0s;
  color: #333;
}

.ei-header .tools .search.s {
  opacity: 1;
  filter: alpha(opacity='100');
  visibility: visible;
}

.ei-header .tools .search .kw {
  display: block;
  float: left;
  height: 20px;
  line-height: 20px;
  width: 190px;
  margin: 8px 0 0 12px;
  font-size: 16px;
}

.ei-header .tools .search .ok {
  float: right;
  width: 36px;
  height: 36px;
  cursor: pointer;
  font-family: icon, serif;
  font-size: 22px;
}


.ei-header2 {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 3;
  background: #94070a;
  opacity: 0;
  transform: translateY(-100%);
  transition: all 0.5s ease-out 0s;
}

.ei-header2.show {
  opacity: 1;
  transform: none;
}

.ei-header2 .d1 {
  background: #94070a;
  color: #d39797;
  line-height: 45px;
  height: 45px;
  font-size: 14px;
  transition: all 0.2s ease-out 0s;
  overflow: hidden;
}

.ei-header2.lit .d1 {
  height: 0;
}

.ei-header2 .d1 .nav_l i {
  margin: 0 18px;
  font-size: 12px;
}

.ei-header2 .d1 .nav_l a {
  display: inline-block;
  line-height: 1;
}

.ei-header2 .d1 .nav_l a:before {
  content: "";
  display: block;
  margin-bottom: 5px;
  border-top: 2px solid #d39797;
  transition: all 0.1s ease-out 0s;;
  transform: scaleX(0);
}

.ei-header2 .d1 .nav_l a.now {
  color: #fff;
}

.ei-header2 .d1 .nav_l a.now:before {
  transform: scaleX(1);
  border-color: #fff;
}

.ei-header2 .d1 .nav_l a:hover:before {
  transform: scaleX(1);
  border-color: #fff;
}

.ei-header2 .d1 .nav_r a {
  margin-left: 30px;
}

.ei-header2 .d1 .nav_r a {
  display: inline-block;
  line-height: 1;
}

.ei-header2 .d1 .nav_r a:before {
  content: "";
  display: block;
  margin-bottom: 5px;
  border-top: 2px solid #d39797;
  transition: all 0.1s ease-out 0s;;
  transform: scaleX(0);
}

.ei-header2 .d1 .nav_r a.now {
  color: #fff;
}

.ei-header2 .d1 .nav_r a.now:before {
  transform: scaleX(1);
  border-color: #fff;
}

.ei-header2 .d1 .nav_r a:hover:before {
  transform: scaleX(1);
  border-color: #fff;
}

.ei-header2 .d2 {
  transition: all 0.3s ease-out 0s;
  height: 70px;
  background: #fff;
}

.ei-header2 .d2 .logo img {
  height: 60px;
}

.ei-header2 .block {
  position: relative;
  height: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-align: center;
  align-items: center;
  margin: auto;
}

.ei-header2 .logo {
  height: 100%;
  width: 200px;
  min-width: 350px;
  display: inline-block;
  vertical-align: top;
  margin-left: 30px;
}

.ei-header2 .logo a {
  height: 100%;
  font-size: 0;
  display: block;
}

.ei-header2 .logo img {
  vertical-align: middle;
  display: inline-block;
}

.ei-header2 .logo a:after {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

.ei-header2 .nav_main {
  text-align: center;
  font-size: 18px;
  margin-left: 30px;
  display: inline-block;
  height: 60px;
  line-height: 60px
}

.ei-header2 .nav_main a {
  margin: 0 25px;
  display: inline-block;
  position: relative;
  font-size: 24px;
  width: 80px;
}

.ei-header2 .nav_main a:after {
  content: "";
  border-bottom: 2px solid #94070a;
  margin-top: 5px;
  display: block;
  width: 100%;
  transition: all 0.2s ease-out 0s;
  transform: scaleX(0);
}

.ei-header2 .nav_main a:before {
  content: "";
  border-left: 2px solid #94070a;
  height: 25px;
  transition: all 0.2s ease-out 0s;
  transform: scaleY(0);
  position: absolute;
  left: 50%;
  top: 100%;
  transform-origin: center top;
}

.ei-header2 .nav_main a.hover:before {
  transform: none;
}

.ei-header2 .nav_main a.hover:after {
  transform: none;
}

.ei-header2 .nav_main a.now:after {
  transform: none;
}
.ei-header2 .nav_main a:hover{
  background: yellow;
  -webkit-background-clip: text;
  text-shadow: 0 0 10px white,
  0 0 20px white,
  0 0 30px black;
}
.ei-header .nav_main a:hover{
 /* background: #DA0C30;
  -webkit-background-clip: text;
  text-shadow: 0 0 10px red;*/

}

.ei-header2 .nav_main a{
 /* background: linear-gradient(50deg, #14ffe9, #ffeb3b, #ff00e0);*/
 /* -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;*/
  animation: eiHeader2A 4s linear infinite;

}
@keyframes eiHeader2A {
0%{
  color: black;
}
 50%{
   color: #94070a;
 }
  100%{
    color: black;
  }
}

.ei-header .nav_main a{
  /*background: linear-gradient(20deg, #14ffe9, #ffeb3b, #ff00e0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: eiHeaderA 4s linear infinite;*/
}
/*@keyframes eiHeaderA {
  to{
    filter: hue-rotate(360deg);
  }
}*/

.ei-header2 .tools {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.ei-header2 .tools .a {
  border: 1px solid #333;
  border-radius: 100%;
  margin-left: 20px;
  width: 36px;
  height: 36px;
  line-height: 36px;
  position: relative;
}

.ei-header2 .tools .a > a {
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  height: 100%;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
}


.ei-header2 .tools .lang {
  font-size: 16px;
  font-family: Arial, serif;
  text-transform: uppercase;
}

.ei-header2 .tools .search {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  width: 250px;
  height: 36px;
  position: absolute;
  right: -2px;
  top: 0;
  opacity: 0;
  filter: alpha(opacity='0');
  visibility: hidden;
  transition: all 0.2s ease-out 0s;
  -webkit-transition: all 0.2s ease-out 0s;
  color: #333;
}

.ei-header2 .tools .search.s {
  opacity: 1;
  filter: alpha(opacity='100');
  visibility: visible;
}

.ei-header2 .tools .search .kw {
  display: block;
  float: left;
  height: 20px;
  line-height: 20px;
  width: 190px;
  margin: 8px 0 0 12px;
  font-size: 16px;
}

.ei-header2 .tools .search .ok {
  float: right;
  width: 36px;
  height: 36px;
  cursor: pointer;
  font-family: icon, serif;
  font-size: 22px;
}
* img,span,a,div{
 user-select: none;
  -webkit-user-drag:none;
}
</style>
